import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';

export enum ExpanderTheme {
    White = 'white',
    Blue = 'blue',
    Red = 'red',
    Gray = 'gray',
    Glass = 'glass',
}

export enum ExpanderButtonStyle {
    NoRounding = 'norounding',
    Rounded = 'rounded',
}

export enum ExpanderBorderRoundingStyle {
    NoRounding = 'norounding',
    Rounded = 'rounded',
}

export enum ExpanderBorderStyle {
    None = 'noBorder',
    Solid = 'solidBorder',
}

export enum ExpanderExpandedHeaderTheme {
    None = 'none',
    Blue = 'blue',
}

export const Expander: React.FC<{
    header: any;
    headerExpanded?: any;
    children?: any;
    theme: ExpanderTheme;
    buttonStyle: ExpanderButtonStyle;
    borderRoundingStyle: ExpanderBorderRoundingStyle;
    borderStyle?: ExpanderBorderStyle;
    expandedHeaderTheme?: ExpanderExpandedHeaderTheme;
    width?: string;
    height?: string;
    initialExpanded?: boolean;
    handleClick?: React.MouseEventHandler;
    expandOnButtonClickOnly?: boolean;
}> = ({
    header,
    headerExpanded = header,
    children,
    theme,
    buttonStyle,
    borderRoundingStyle,
    borderStyle = ExpanderBorderStyle.None,
    expandedHeaderTheme = ExpanderExpandedHeaderTheme.None,
    width = 'auto',
    height = '50px',
    initialExpanded = false,
    handleClick,
    expandOnButtonClickOnly = false,
}) => {
    const [isExpanded, set_isExpanded] = useState(initialExpanded);
    const contentRef = useRef<HTMLDivElement>(null);

    const setStyle = {
        width: `${width}`,
    };

    const setHeaderStyle = {
        height: `${height}`,
        cursor: expandOnButtonClickOnly ? 'cursor' : 'pointer',
    };

    const onExpandCollapsePanelClick: React.MouseEventHandler = (e) => {
        if (expandOnButtonClickOnly) {
            return;
        } else {
            onExpandCollapseClick(e);
        }
    };

    const onExpandCollapseClick: React.MouseEventHandler = (e) => {
        if (isExpanded) {
            set_isExpanded(false);
        } else {
            set_isExpanded(true);
        }

        if (handleClick) {
            handleClick(e);
        }
    };

    return (
        <>
            <div
                className={`expander ${theme} ${borderStyle} ${borderRoundingStyle}`}
                style={setStyle}
            >
                <div
                    className={`expanderHeader ${expandedHeaderTheme} ${isExpanded ? 'expanded' : 'collapsed'}`}
                    style={setHeaderStyle}
                    onClick={onExpandCollapsePanelClick}
                >
                    <div className='expanderHeaderText'>{isExpanded ? headerExpanded : header}</div>{' '}
                    <div
                        className={`expanderButton ${buttonStyle} ${theme}`}
                        onClick={onExpandCollapseClick}
                    >
                        <FontAwesomeIcon
                            icon={isExpanded ? faChevronUp : faChevronDown}
                            className='expanderHeaderButton-image'
                        />
                    </div>
                </div>
                <div className={`expanderContentContainer ${isExpanded ? 'expanded' : 'collapsed'}`}>
                    <div
                        ref={contentRef}
                        className={`expanderContent ${isExpanded ? 'expanded' : 'collapsed'}`}
                    >
                        {children}
                    </div>
                </div>
            </div>
        </>
    );
};
